const products = [
  {
    slug: "erp",
    name: "Byteflow ERP",
    shortName: "ERP",
    flagship: true,
    icon: "🏢",
    tagline: "Run your business on one platform.",
    blurb:
      "A modular ERP that unifies sales, purchase, inventory, finance, HR, planning, costing, and maintenance for small businesses and manufacturers.",
    heroSummary:
      "Byteflow ERP is our flagship product — a single, modular platform that small businesses and manufacturers use to replace a stack of disconnected spreadsheets and tools.",
    accent: "#22c55e",
    image: "/about-erp.jpg",
    features: [
      { icon: "🤝", title: "Sales", desc: "Quotations, sales orders, dispatch, and GST-ready invoicing." },
      { icon: "🛒", title: "Purchase", desc: "Vendor management, purchase orders, GRN, and approvals." },
      { icon: "📦", title: "Inventory", desc: "Real-time stock, multi-warehouse, batch and serial tracking." },
      { icon: "💰", title: "Finance", desc: "Ledgers, receivables and payables, GST returns, and reports." },
      { icon: "👥", title: "HR", desc: "Payroll, attendance, leave, and statutory compliance." },
      { icon: "📅", title: "Planning", desc: "Production planning, MRP, work orders, and scheduling." },
      { icon: "🧮", title: "Costing", desc: "BOM and job costing, overheads, and variance analysis." },
      { icon: "🔧", title: "Maintenance", desc: "Preventive schedules, breakdown logs, spares, and AMC tracking." },
    ],
    industries: ["Manufacturing", "Retail", "Distribution", "Services"],
    pricing: [
      { name: "Small Business", audience: "For small teams digitising their core operations.", features: ["Core modules (Sales, Purchase, Inventory, Finance)", "Single location", "Cloud hosting", "Email support"] },
      { name: "Growth", audience: "For growing companies that need connected operations.", featured: true, features: ["Core + HR, Planning, Costing & Maintenance", "Multi-branch ready", "Advanced reporting & dashboards", "Priority support"] },
      { name: "Enterprise", audience: "For multi-branch manufacturers and distributors.", features: ["Full modular suite — only the modules you need", "Unlimited users, multi-company", "Custom integrations & API", "On-prem or cloud · dedicated manager · 24/7"] },
    ],
  },
  {
    slug: "courier",
    name: "Byteflow Courier",
    shortName: "Courier",
    icon: "🚚",
    tagline: "Track every parcel. Optimise every route.",
    blurb:
      "A courier management system for last-mile and intercity logistics — booking, tracking, route planning, and COD reconciliation.",
    heroSummary:
      "Byteflow Courier is built for courier companies and in-house logistics teams. From the moment a shipment is booked to the moment it’s delivered, every parcel, driver, and rupee is accounted for.",
    accent: "#2563eb",
    image: "/about-erp.jpg",
    features: [
      { icon: "📋", title: "Shipment Booking", desc: "Walk-in, online, and bulk booking with auto-generated AWB numbers." },
      { icon: "📍", title: "Real-time Tracking", desc: "GPS-based status from pickup to delivery, shared with customers." },
      { icon: "🗺️", title: "Route Optimisation", desc: "Auto-plan delivery routes by zone, load, and time window." },
      { icon: "💰", title: "COD Reconciliation", desc: "Track cash-on-delivery collections and reconcile with drivers daily." },
      { icon: "📱", title: "Driver App", desc: "On-the-road app for pickups, deliveries, signatures, and proof of delivery." },
      { icon: "🔔", title: "Customer Notifications", desc: "Automated SMS, email, and WhatsApp updates at every stage." },
    ],
    industries: ["Logistics", "E-commerce", "Retail", "Distribution"],
    pricing: [
      { name: "Starter", audience: "For new courier services and single-branch operations.", features: ["Up to 500 shipments/mo", "Single branch", "Basic tracking", "Email support"] },
      { name: "Professional", audience: "For scaling courier networks with multiple branches and drivers.", featured: true, features: ["Up to 5,000 shipments/mo", "Multi-branch", "Route optimisation", "Driver app + COD reconciliation"] },
      { name: "Enterprise", audience: "For high-volume logistics operators with custom requirements.", features: ["Unlimited shipments", "API integrations", "Dedicated account manager", "24/7 support"] },
    ],
  },
  {
    slug: "medical",
    name: "Byteflow Pharma",
    shortName: "Pharma",
    icon: "💊",
    tagline: "Pharmacy retail and field force, on one platform.",
    blurb:
      "Software for medical stores and pharma field teams — GST billing, inventory, and batch/expiry tracking for retail, plus call reporting and order booking for medical representatives.",
    heroSummary:
      "Byteflow Pharma brings the two sides of the medicine business together — a complete Medical Store Management system for pharmacies, and a mobile MR App for pharma field reps.",
    accent: "#ef4444",
    image: "/about-erp.jpg",
    features: [
      { icon: "🧾", title: "Billing & GST", desc: "Fast retail billing with GST invoicing, returns, and daily cash reports." },
      { icon: "📦", title: "Batch & Expiry", desc: "Batch-wise stock with expiry alerts and near-expiry reporting." },
      { icon: "🏪", title: "Multi-Store Inventory", desc: "Central stock view, inter-branch transfers, and purchase automation." },
      { icon: "🧑‍⚕️", title: "MR Call Reporting", desc: "Daily doctor and chemist visit logs with tour plans and approvals." },
      { icon: "🛒", title: "Order Booking", desc: "Field order capture with sample and gift tracking for reps." },
      { icon: "📍", title: "Geo-tagged Visits", desc: "Location-verified visits and live manager dashboards." },
    ],
    industries: ["Pharmacies", "Medical store chains", "Pharma distributors", "Pharma field teams"],
    pricing: [
      { name: "Medical Store", audience: "For single pharmacies and medical retail.", features: ["GST billing & returns", "Batch & expiry tracking", "Inventory & supplier management", "Email support"] },
      { name: "Field Force (MR App)", audience: "For pharma sales and field teams.", featured: true, features: ["MR call reporting & tour plans", "Order booking & sample tracking", "Geo-tagged visits", "Manager dashboards"] },
      { name: "Pharma Suite", audience: "For chains and pharma companies running both.", features: ["Medical Store + MR App together", "Multi-store / multi-division", "Distributor & ERP integration", "BI analytics · dedicated support"] },
    ],
  },
  {
    slug: "school",
    name: "Byteflow School",
    shortName: "School",
    icon: "🎓",
    tagline: "Run your entire school on a single platform.",
    blurb:
      "An all-in-one school management platform — admissions, academics, fees, HR, library, attendance, and exams, on web and mobile, in one connected system.",
    heroSummary:
      "From the first admission enquiry to alumni — Byteflow School connects admissions, academics, finance, HR, library, and parent communication so administrators, teachers, students, and parents all work from the same source of truth. One campus today, a multi-branch group tomorrow.",
    accent: "#a855f7",
    image: "/about-erp.jpg",
    audienceWord: "schools",
    stats: [
      { value: "13", label: "Integrated suites" },
      { value: "4", label: "Mobile role portals" },
      { value: "100+", label: "Functional modules" },
      { value: "45", label: "Days to go live" },
    ],
    features: [
      { icon: "📝", title: "Admissions & Enrolment", desc: "Enquiry-to-enrolment funnel with screening, assessments, seat offers, and conversion reports." },
      { icon: "🎓", title: "Student Lifecycle & Records", desc: "One authoritative record from enrolment to alumni — profiles, guardians, documents, promotions." },
      { icon: "📚", title: "Academics & Teaching", desc: "Curriculum planning, lesson tracking, digital assignments, grading, and teacher workload." },
      { icon: "🗓️", title: "Timetable & Attendance", desc: "Conflict-free timetable builder, automatic substitutions, and period-wise attendance." },
      { icon: "🏆", title: "Examinations & Reporting", desc: "Any exam pattern, audited mark entry, grading scales, and auto-generated report cards." },
      { icon: "💳", title: "Fees & Finance", desc: "Flexible fee structures, auto-invoicing, online payments, scholarships, fines, and ledgers." },
      { icon: "👥", title: "HR & Payroll", desc: "A full HRMS for teaching and non-teaching staff — records, leave, payroll runs, and self-service." },
      { icon: "📖", title: "Library", desc: "Catalog, circulation, holds, acquisitions, digital resources, and OPAC self-service." },
      { icon: "📣", title: "Communication & Portals", desc: "Notices, real-time alerts, and self-service portals for students, parents, and teachers." },
      { icon: "🛡️", title: "Discipline & Welfare", desc: "Disciplinary cases, hearing panels, and a confidential desk for sensitive matters." },
      { icon: "⚙️", title: "Administration & Security", desc: "Multi-branch settings, granular roles, ID card designer, dashboards, and full audit logs." },
    ],
    whyChoose: [
      { icon: "🧩", title: "Truly all-in-one", desc: "Admissions to alumni, fees to payroll, library to discipline — deep modules, never checkbox features." },
      { icon: "🚀", title: "Live in 45 days", desc: "Full deployment with your fee rules, report cards, and workflows — not a 4–6 month project." },
      { icon: "📱", title: "4 native apps included", desc: "Role-specific apps for students, teachers, parents, and admins — bundled, never a paid add-on." },
      { icon: "🏫", title: "Multi-branch by design", desc: "Branch-level rules, switching, and group-wide reporting without re-implementation." },
      { icon: "🗓️", title: "Automatic timetabling", desc: "Constraint-aware engine covering availability, workload, rooms, and substitution cover." },
      { icon: "💰", title: "Finance-grade fees", desc: "Approval panels, cashier reconciliation, audited overrides, and a real financial ledger." },
      { icon: "🔐", title: "Enterprise security", desc: "Granular permissions, complete audit trails, and document vaults — inspection-ready by default." },
      { icon: "👩‍🏫", title: "Teacher-first operations", desc: "Competencies, workload tracking, and automated substitution cover for every school." },
    ],
    mobileApps: [
      {
        icon: "🎒",
        name: "Student App",
        points: ["Personalised home dashboard", "Attendance % and daily log", "Assignments — view & submit", "Marks & teacher feedback", "Fees — view & pay online", "Timetable, notices & leave requests"],
      },
      {
        icon: "👩‍🏫",
        name: "Teacher App",
        points: ["Classes & today's periods", "Mark attendance on the go", "Create & review assignments", "Markbook and grading", "Student leave approvals inbox", "Timetable, roster & notices"],
      },
      {
        icon: "👨‍👩‍👧",
        name: "Parent App",
        points: ["Multi-child switcher", "Child's attendance in real time", "Assignments & teacher feedback", "Fees — view & pay online", "Class-teacher contact", "Instant alerts on absence & notices"],
      },
      {
        icon: "🧑‍💼",
        name: "Admin App",
        points: ["Branch switcher (multi-campus)", "Live KPIs: students, staff, classes", "Admissions-this-month tracker", "Enrolment & class charts", "Leave approvals (staff & students)", "School-wide notices"],
      },
    ],
    planTitle: "Live in 45 days — customised to your school",
    planLead:
      "Full deployment including your fee rules, report cards, ID cards, workflows, and data migration — before the next term starts.",
    implementationPlan: [
      { phase: "Discovery & setup", days: "Days 1–7", desc: "Branches, academic years, classes & sections, roles, and master data." },
      { phase: "Data migration", days: "Days 8–15", desc: "Students, guardians, staff, fee structures, and opening balances." },
      { phase: "Customization", days: "Days 16–30", desc: "Report cards, ID cards, fee rules, grading scales, workflows, and branding." },
      { phase: "Training & pilot", days: "Days 31–40", desc: "Role-wise staff training, parallel run, and mobile app rollout." },
      { phase: "Go-live & handover", days: "Days 41–45", desc: "Production cutover, hypercare support, and sign-off." },
    ],
    beforeAfter: [
      { task: "Collecting fees", before: "Cash at the desk, manual receipts, chasing defaulters by phone", after: "Online payments, auto-invoices, automatic reminders & defaulter reports" },
      { task: "Marking attendance", before: "Paper registers, no parent visibility", after: "One tap on the teacher app; parents notified instantly" },
      { task: "Report cards", before: "Manual spreadsheets, hours of formatting", after: "Marks roll up automatically into branded report cards" },
      { task: "Admissions", before: "Enquiries lost in inboxes & notebooks", after: "Structured funnel from enquiry → assessment → seat offer" },
      { task: "Payroll & HR", before: "Outsourced or in spreadsheets, disconnected", after: "Built-in HRMS: leave, attendance, payroll & payslips" },
      { task: "Parent updates", before: "Diary notes & phone calls", after: "Real-time mobile app: marks, fees, notices, attendance" },
    ],
    industries: ["K-12 schools", "International schools", "Pre-schools", "Coaching & colleges"],
    pricing: [
      { name: "Single School", audience: "For a single campus going digital.", features: ["Admissions, academics, fees & exams", "Student, teacher & parent apps", "45-day guided implementation", "Email support"] },
      { name: "Multi-Campus", audience: "For trusts and chains with several branches.", featured: true, features: ["Everything in Single School", "Branch switching & group-wide reporting", "HR & payroll + library", "Priority support"] },
      { name: "Global / Enterprise", audience: "For international and multi-curriculum institutions.", features: ["Multi-country, multi-currency & language", "Cambridge / IB / CBSE support", "SSO & role-based regional access", "Custom integrations · dedicated success manager"] },
    ],
  },
  {
    slug: "ecommerce",
    name: "Byteflow Commerce",
    shortName: "Commerce",
    icon: "🛍️",
    tagline: "Launch and scale your online store.",
    blurb:
      "Custom e-commerce websites — storefront, catalog, payments, and ERP-synced inventory, built to scale from your first sale to high volume.",
    heroSummary:
      "Byteflow Commerce is our e-commerce build — a fast, custom online store with catalog, cart, payments, and inventory that can sync straight to your Byteflow ERP.",
    accent: "#f59e0b",
    image: "/about-erp.jpg",
    features: [
      { icon: "🛒", title: "Storefront & Catalog", desc: "Custom-designed store with categories, search, and filters." },
      { icon: "💳", title: "Payments & Checkout", desc: "Multiple gateways, COD, coupons, and secure checkout." },
      { icon: "🔗", title: "ERP Inventory Sync", desc: "Live stock and pricing synced with Byteflow ERP." },
      { icon: "🚚", title: "Shipping & Logistics", desc: "Multiple shipping options, tracking, and courier integration." },
      { icon: "📈", title: "SEO & Analytics", desc: "SEO-ready pages, performance tuning, and sales analytics." },
      { icon: "🧑‍💼", title: "B2B & Multi-vendor", desc: "Optional wholesale pricing or a multi-vendor marketplace." },
    ],
    industries: ["Retail", "D2C brands", "Wholesale / B2B", "Distributors"],
    pricing: [
      { name: "Launch", audience: "For getting your first store online.", features: ["Storefront + catalog", "Cart & payment gateway", "Basic SEO setup", "Email support"] },
      { name: "Business", audience: "For established retailers scaling online.", featured: true, features: ["Custom design", "ERP inventory sync", "Coupons & multi payment/shipping", "Analytics & priority support"] },
      { name: "Enterprise", audience: "For high-volume, B2B, or multi-vendor commerce.", features: ["Headless / custom build", "B2B or multi-vendor", "ERP + CRM integration", "Performance, scale & SLA"] },
    ],
  },
];

export const getProduct = (slug) => products.find((p) => p.slug === slug);

export default products;
